// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");

function padCount(n) {
  if (n < 10) {
    return "0" + String(n);
  } else {
    return String(n);
  }
}

function SurveySummaryCards$ScoreCard(props) {
  var __compact = props.compact;
  var onClick = props.onClick;
  var __selected = props.selected;
  var subtitle = props.subtitle;
  var selected = __selected !== undefined ? __selected : false;
  var compact = __compact !== undefined ? __compact : false;
  var interactive = Belt_Option.isSome(onClick);
  var baseClass = "bg-white rounded-xl border shadow-sm flex items-start justify-between min-w-0 text-left w-full " + (
    compact ? "p-3 " : "p-4 lg:p-5 "
  ) + (
    selected ? "border-pigmentblue ring-2 ring-pigmentblue ring-opacity-20" : "border-gray-200"
  ) + (
    interactive ? " cursor-pointer hover:border-pigmentblue transition-colors" : ""
  );
  var valueClass = compact ? "text-xl lg:text-2xl" : "text-2xl lg:text-3xl";
  var content = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                        children: props.label,
                        className: "text-10-px lg:text-xs font-semibold text-aurometalsaurus uppercase tracking-wide mb-1 truncate"
                      }),
                  JsxRuntime.jsx("p", {
                        children: props.value,
                        className: valueClass + " font-bold text-darkcharcoal mb-1"
                      }),
                  subtitle !== undefined ? JsxRuntime.jsx("p", {
                          children: subtitle,
                          className: "text-10-px lg:text-xs text-aurometalsaurus truncate"
                        }) : null
                ],
                className: "min-w-0 flex-1"
              }),
          JsxRuntime.jsx("div", {
                children: props.icon,
                className: (
                  compact ? "w-8 h-8 text-sm " : "w-9 h-9 lg:w-10 lg:h-10 text-base lg:text-lg "
                ) + "rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0 ml-2"
              })
        ]
      });
  if (onClick !== undefined) {
    return JsxRuntime.jsx("button", {
                children: content,
                className: baseClass,
                type: "button",
                onClick: (function (param) {
                    Curry._1(onClick, undefined);
                  })
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: content,
                className: baseClass
              });
  }
}

var ScoreCard = {
  make: SurveySummaryCards$ScoreCard
};

function empty(param) {
  return {
          projectTotalCount: 0,
          liveCount: 0,
          pageCount: 0,
          searchSummary: "Visible in this project"
        };
}

function SurveySummaryCards$Row(props) {
  var __compact = props.compact;
  var onLiveToggle = props.onLiveToggle;
  var liveOnly = props.liveOnly;
  var stats = props.stats;
  var compact = __compact !== undefined ? __compact : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SurveySummaryCards$ScoreCard, {
                      label: "Project Surveys",
                      value: padCount(stats.projectTotalCount),
                      subtitle: "Available in this project",
                      icon: "📋",
                      compact: compact
                    }),
                JsxRuntime.jsx(SurveySummaryCards$ScoreCard, {
                      label: "Live Surveys",
                      value: padCount(stats.liveCount),
                      subtitle: liveOnly ? "Showing live surveys" : "Click to view live surveys",
                      icon: "🟢",
                      selected: liveOnly,
                      onClick: (function (param) {
                          Curry._1(onLiveToggle, undefined);
                        }),
                      compact: compact
                    }),
                JsxRuntime.jsx(SurveySummaryCards$ScoreCard, {
                      label: "Visible Surveys",
                      value: padCount(stats.pageCount),
                      subtitle: stats.searchSummary,
                      icon: "📄",
                      compact: compact
                    })
              ],
              className: "grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-3"
            });
}

var Row = {
  make: SurveySummaryCards$Row
};

exports.padCount = padCount;
exports.ScoreCard = ScoreCard;
exports.empty = empty;
exports.Row = Row;
/* react/jsx-runtime Not a pure module */
